const foundationsColors = {
  neutral: {
    0: "#FFFFFF",
    50: "#F3F3F3",
    100: "#EAEAEA",
    200: "#E0E0E0",
    300: "#D0D0D0",
    400: "#A8A8A8",
    500: "#7D7D7D",
    600: "#5E5E5E",
    700: "#333333",
    800: "#2A2A2A",
    900: "#1E1E1E",
    950: "#121212",
  },
  brand: {
    50: "#FFF2F1",
    100: "#FFE3E1",
    200: "#FFC8C8",
    300: "#FFA6A1",
    400: "#FE726B",
    500: "#F7453C",
    600: "#E1251B",
    700: "#C01E15",
    800: "#9F1C15",
    900: "#831E19",
    950: "#480A07",
  },
  blue: {
    50: "#EBF1FF",
    100: "#D5E2FF",
    200: "#C0D5FF",
    300: "#97BAFF",
    400: "#6895FF",
    500: "#335CFF",
    600: "#3559E9",
    700: "#2547D0",
    800: "#1F3BAD",
    900: "#182F8B",
    950: "#122368",
  },
  orange: {
    50: "#FFF1EB",
    100: "#FFE3D5",
    200: "#FFD5C0",
    300: "#FFBA97",
    400: "#FF9A68",
    500: "#FF8447",
    600: "#E97135",
    700: "#D05E25",
    800: "#AD4E1F",
    900: "#8B3E18",
    950: "#682F12",
  },
  red: {
    50: "#FFEBEC",
    100: "#FFD5D8",
    200: "#FFC0C5",
    300: "#FF97A0",
    400: "#FF6875",
    500: "#FB3748",
    600: "#E93544",
    700: "#D02533",
    800: "#AD1F2B",
    900: "#8B1822",
    950: "#681219",
  },
  green: {
    50: "#E0FAEC",
    100: "#D0FBE9",
    200: "#C2F5DA",
    300: "#84EBB4",
    400: "#3EE089",
    500: "#1FC16B",
    600: "#1DAF61",
    700: "#178C4E",
    800: "#1A7544",
    900: "#16643B",
    950: "#0B4627",
  },
  yellow: {
    50: "#FFFAEB",
    100: "#FFEFCC",
    200: "#FFECC0",
    300: "#FFE097",
    400: "#FFD268",
    500: "#F6B51E",
    600: "#E6A819",
    700: "#C99A2C",
    800: "#A78025",
    900: "#86661D",
    950: "#624C18",
  },
  purple: {
    50: "#EFEBFF",
    100: "#DCD5FF",
    200: "#CAC0FF",
    300: "#A897FF",
    400: "#8C71F6",
    500: "#7D52F4",
    600: "#693EE0",
    700: "#5B2CC9",
    800: "#4C25A7",
    900: "#3D1D86",
    950: "#351A75",
  },
  sky: {
    50: "#EBF8FF",
    100: "#D5F1FF",
    200: "#C0EAFF",
    300: "#97DCFF",
    400: "#68CDFF",
    500: "#47C2FF",
    600: "#35ADE9",
    700: "#2597D0",
    800: "#1F7EAD",
    900: "#18658B",
    950: "#124B68",
  },
  alphas: {
    neutral: {
      "alpha-10": "rgba(153, 160, 174, 0.1)",
      "alpha-16": "rgba(153, 160, 174, 0.16)",
      "alpha-24": "rgba(153, 160, 174, 0.24)",
    },
    brand: {
      "alpha-10": "rgba(229, 42, 45, 0.1)",
      "alpha-16": "rgba(229, 42, 45, 0.16)",
      "alpha-24": "rgba(229, 42, 45, 0.24)",
    },
    blue: {
      "alpha-10": "rgba(71, 108, 255, 0.1)",
      "alpha-16": "rgba(71, 108, 255, 0.16)",
      "alpha-24": "rgba(71, 108, 255, 0.24)",
    },
    red: {
      "alpha-10": "rgba(251, 55, 72, 0.1)",
      "alpha-16": "rgba(251, 55, 72, 0.16)",
      "alpha-24": "rgba(251, 55, 72, 0.24)",
    },
    green: {
      "alpha-10": "rgba(31, 193, 107, 0.1)",
      "alpha-16": "rgba(31, 193, 107, 0.16)",
      "alpha-24": "rgba(31, 193, 107, 0.24)",
    },
    yellow: {
      "alpha-10": "rgba(251, 198, 75, 0.1)",
      "alpha-16": "rgba(251, 198, 75, 0.16)",
      "alpha-24": "rgba(251, 198, 75, 0.24)",
    },
    purple: {
      "alpha-10": "rgba(120,77,239, 0.1)",
      "alpha-16": "rgba(120,77,239, 0.16)",
      "alpha-24": "rgba(120,77,239, 0.24)",
    },
  },
};

export default foundationsColors;
